import type { ContratApprentissageDTO } from '@/features/api/extranet/dto/Demande/CAPP'

import type { LovCappDTO } from '@/features/api/extranet/dto/Demande/CAPP'
import { propertyStatusConfiguration, reglesConfiguration } from '@/features/domaine/regles-akto/CAPP'
import { cappService } from '@/features/services/demande'
import { buildDemandeStore } from '../shared'

export const useDemandeCAPPStore = buildDemandeStore<ContratApprentissageDTO, LovCappDTO>({
  dispositif: 'CAPP',
  demandeService: cappService,
  propertyStatusConfiguration,
  reglesConfiguration,
})
